import { pDelay } from '@naturalcycles/js-lib/promise'
import { useEffect, useState } from 'react'

type Props = {
  badgeUrl: string
}

const NetlifyStatusBadge = ({ badgeUrl }: Props) => {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    const reload = () => {
      setShowBadge(false)
      pDelay().then(() => {
        setShowBadge(true)
      })
    }
    reload()
    const interval = setInterval(reload, 10000)
    return () => clearInterval(interval)
  }, [badgeUrl])

  if (!showBadge) return null

  return <img className='w-40' src={badgeUrl} alt={`Netlify status badge`} />
}

export default NetlifyStatusBadge
